// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewMore_mainContainer__HTu8q {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background-color: #1a1a1a;
  color: white;
  border-radius: 12px;
}

.ViewMore_title__j-7tL {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 2rem;
}

.ViewMore_outerContainer__Byc8A {
  position: relative;
}

.ViewMore_episodesContainer__K3fHD {
  width: 100%;
  height: 480px; /* Increased height for 3 rows */
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.ViewMore_episodesContainer__K3fHD::-webkit-scrollbar {
  display: none;
}

.ViewMore_episodesGrid__hSt7i {
  display: grid;
  grid-template-columns: repeat(6, 1fr); /* 6 columns */
  grid-template-rows: repeat(2, 1fr); /* 2 rows */
  gap: 24px;
  height: 100%;
  width: max-content; /* Ensures horizontal scrolling */
  padding: 1rem;
}

/* Updated episodeCard with pointer, transitions, hover, active, and focus styles */
.ViewMore_episodeCard__lVjSL {
  width: 350px;
  height: 180px;
  display: flex;
  align-items: center;
  background-color: #2a2a2a;
  border-radius: 12px;
  padding: 1rem;
  cursor: pointer; /* Pointer on hover */
  transition: transform 0.2s ease, background-color 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
}

.ViewMore_episodeCard__lVjSL:hover {
  background-color: #3a3a3a; /* Lighter on hover */
  transform: scale(1.02); /* Slight zoom effect */
}

.ViewMore_episodeCard__lVjSL:active {
  transform: scale(0.98); /* Press effect */
}

.ViewMore_episodeCard__lVjSL:focus {
  outline: 2px solid #ff0000;
  outline-offset: 2px;
}

/* Selected/Active episode style */
.ViewMore_episodeCard__lVjSL.ViewMore_selected__BFC7m {
  background-color: #3f1d1d; /* Reddish tint for selected episode */
  box-shadow: 0 0 15px rgba(255, 0, 0, 0.3); /* Red glow */
  transform: scale(1.02);
}

/* Optional: Remove focus outline when not keyboard navigating */
.ViewMore_episodeCard__lVjSL:focus:not(:focus-visible) {
  outline: none;
}

.ViewMore_imageContainer__Rn8hG {
  width: 150px;
  height: 150px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 1.5rem;
  position: relative;
}

.ViewMore_episodeImage__vSrtb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #3a3a3a;
}

.ViewMore_playOverlay__lAsAH {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease, background-color 0.2s ease;
}

.ViewMore_episodeCard__lVjSL:hover .ViewMore_playOverlay__lAsAH,
.ViewMore_episodeCard__lVjSL.ViewMore_selected__BFC7m .ViewMore_playOverlay__lAsAH {
  opacity: 1;
}

.ViewMore_episodeCard__lVjSL.ViewMore_selected__BFC7m .ViewMore_playOverlay__lAsAH {
  background-color: rgba(255, 0, 0, 0.7); /* Red background for the play button when selected */
}

.ViewMore_episodeInfo__XDoJY {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.ViewMore_episodeTitle__fDKg3 {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
  color: white;
}

.ViewMore_episodeSubtitle__bZJV7 {
  font-size: 0.875rem;
  color: #999;
  margin: 0;
}

.ViewMore_episodeDetails__itvHx {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-top: 0.5rem;
}

.ViewMore_episodeDuration__d9ejM, .ViewMore_episodeType__6eo37 {
  font-size: 0.875rem;
  color: #999;
  display: flex;
  align-items: center;
}

.ViewMore_episodeType__6eo37 {
  background-color: rgba(255, 0, 0, 0.2);
  color: #ff6b6b;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
}

.ViewMore_scrollTrack__FOLZ8 {
  position: absolute;
  bottom: 0; /* Stick to bottom */
  left: 0;
  width: 100%;
  height: 6px; /* Increased height for visibility */
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 3px;
  margin-top: 0.5rem;
  overflow: hidden;
}

.ViewMore_scrollBar__1Nx-j {
  position: absolute;
  height: 100%;
  width: 30%; /* Initial width */
  background-color: #ff0000;
  border-radius: 3px;
  transform: translateX(0%);
  transition: transform 0.3s ease;
}

/* No episodes message */
.ViewMore_noEpisodes__H93hD {
  width: 100%;
  padding: 3rem;
  text-align: center;
  color: #999;
  font-size: 1.2rem;
  background-color: #2a2a2a;
  border-radius: 12px;
}

@media (max-width: 1200px) {
  .ViewMore_episodeCard__lVjSL {
    width: 320px;
  }
    
  .ViewMore_imageContainer__Rn8hG {
    width: 130px;
    height: 130px;
  }
}

@media (max-width: 768px) {
  .ViewMore_mainContainer__HTu8q {
    width: 95%;
    padding: 1rem;
  }
  
  .ViewMore_episodeCard__lVjSL {
    width: 300px;
    height: 160px;
  }
  
  .ViewMore_imageContainer__Rn8hG {
    width: 120px;
    height: 120px;
  }
  
  .ViewMore_episodeTitle__fDKg3 {
    font-size: 1.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/EpisodeScreen/Component/CSS/ViewMore.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa,EAAE,gCAAgC;EAC/C,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,cAAc;EACrD,kCAAkC,EAAE,WAAW;EAC/C,SAAS;EACT,YAAY;EACZ,kBAAkB,EAAE,iCAAiC;EACrD,aAAa;AACf;;AAEA,mFAAmF;AACnF;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe,EAAE,qBAAqB;EACtC,2DAA2D;EAC3D,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,sBAAsB,EAAE,uBAAuB;AACjD;;AAEA;EACE,sBAAsB,EAAE,iBAAiB;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,yBAAyB,EAAE,sCAAsC;EACjE,yCAAyC,EAAE,aAAa;EACxD,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yDAAyD;AAC3D;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,sCAAsC,EAAE,qDAAqD;AAC/F;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,oBAAoB;EAC/B,OAAO;EACP,WAAW;EACX,WAAW,EAAE,oCAAoC;EACjD,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU,EAAE,kBAAkB;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".mainContainer {\n  width: 90%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  background-color: #1a1a1a;\n  color: white;\n  border-radius: 12px;\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: bold;\n  margin-bottom: 2rem;\n}\n\n.outerContainer {\n  position: relative;\n}\n\n.episodesContainer {\n  width: 100%;\n  height: 480px; /* Increased height for 3 rows */\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.episodesContainer::-webkit-scrollbar {\n  display: none;\n}\n\n.episodesGrid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr); /* 6 columns */\n  grid-template-rows: repeat(2, 1fr); /* 2 rows */\n  gap: 24px;\n  height: 100%;\n  width: max-content; /* Ensures horizontal scrolling */\n  padding: 1rem;\n}\n\n/* Updated episodeCard with pointer, transitions, hover, active, and focus styles */\n.episodeCard {\n  width: 350px;\n  height: 180px;\n  display: flex;\n  align-items: center;\n  background-color: #2a2a2a;\n  border-radius: 12px;\n  padding: 1rem;\n  cursor: pointer; /* Pointer on hover */\n  transition: transform 0.2s ease, background-color 0.2s ease;\n  user-select: none;\n  position: relative;\n}\n\n.episodeCard:hover {\n  background-color: #3a3a3a; /* Lighter on hover */\n  transform: scale(1.02); /* Slight zoom effect */\n}\n\n.episodeCard:active {\n  transform: scale(0.98); /* Press effect */\n}\n\n.episodeCard:focus {\n  outline: 2px solid #ff0000;\n  outline-offset: 2px;\n}\n\n/* Selected/Active episode style */\n.episodeCard.selected {\n  background-color: #3f1d1d; /* Reddish tint for selected episode */\n  box-shadow: 0 0 15px rgba(255, 0, 0, 0.3); /* Red glow */\n  transform: scale(1.02);\n}\n\n/* Optional: Remove focus outline when not keyboard navigating */\n.episodeCard:focus:not(:focus-visible) {\n  outline: none;\n}\n\n.imageContainer {\n  width: 150px;\n  height: 150px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-right: 1.5rem;\n  position: relative;\n}\n\n.episodeImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background-color: #3a3a3a;\n}\n\n.playOverlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 50px;\n  height: 50px;\n  background-color: rgba(0, 0, 0, 0.6);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.2s ease, background-color 0.2s ease;\n}\n\n.episodeCard:hover .playOverlay,\n.episodeCard.selected .playOverlay {\n  opacity: 1;\n}\n\n.episodeCard.selected .playOverlay {\n  background-color: rgba(255, 0, 0, 0.7); /* Red background for the play button when selected */\n}\n\n.episodeInfo {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.episodeTitle {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin: 0;\n  color: white;\n}\n\n.episodeSubtitle {\n  font-size: 0.875rem;\n  color: #999;\n  margin: 0;\n}\n\n.episodeDetails {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  margin-top: 0.5rem;\n}\n\n.episodeDuration, .episodeType {\n  font-size: 0.875rem;\n  color: #999;\n  display: flex;\n  align-items: center;\n}\n\n.episodeType {\n  background-color: rgba(255, 0, 0, 0.2);\n  color: #ff6b6b;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n}\n\n.scrollTrack {\n  position: absolute;\n  bottom: 0; /* Stick to bottom */\n  left: 0;\n  width: 100%;\n  height: 6px; /* Increased height for visibility */\n  background-color: rgba(255, 255, 255, 0.15);\n  border-radius: 3px;\n  margin-top: 0.5rem;\n  overflow: hidden;\n}\n\n.scrollBar {\n  position: absolute;\n  height: 100%;\n  width: 30%; /* Initial width */\n  background-color: #ff0000;\n  border-radius: 3px;\n  transform: translateX(0%);\n  transition: transform 0.3s ease;\n}\n\n/* No episodes message */\n.noEpisodes {\n  width: 100%;\n  padding: 3rem;\n  text-align: center;\n  color: #999;\n  font-size: 1.2rem;\n  background-color: #2a2a2a;\n  border-radius: 12px;\n}\n\n@media (max-width: 1200px) {\n  .episodeCard {\n    width: 320px;\n  }\n    \n  .imageContainer {\n    width: 130px;\n    height: 130px;\n  }\n}\n\n@media (max-width: 768px) {\n  .mainContainer {\n    width: 95%;\n    padding: 1rem;\n  }\n  \n  .episodeCard {\n    width: 300px;\n    height: 160px;\n  }\n  \n  .imageContainer {\n    width: 120px;\n    height: 120px;\n  }\n  \n  .episodeTitle {\n    font-size: 1.25rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `ViewMore_mainContainer__HTu8q`,
	"title": `ViewMore_title__j-7tL`,
	"outerContainer": `ViewMore_outerContainer__Byc8A`,
	"episodesContainer": `ViewMore_episodesContainer__K3fHD`,
	"episodesGrid": `ViewMore_episodesGrid__hSt7i`,
	"episodeCard": `ViewMore_episodeCard__lVjSL`,
	"selected": `ViewMore_selected__BFC7m`,
	"imageContainer": `ViewMore_imageContainer__Rn8hG`,
	"episodeImage": `ViewMore_episodeImage__vSrtb`,
	"playOverlay": `ViewMore_playOverlay__lAsAH`,
	"episodeInfo": `ViewMore_episodeInfo__XDoJY`,
	"episodeTitle": `ViewMore_episodeTitle__fDKg3`,
	"episodeSubtitle": `ViewMore_episodeSubtitle__bZJV7`,
	"episodeDetails": `ViewMore_episodeDetails__itvHx`,
	"episodeDuration": `ViewMore_episodeDuration__d9ejM`,
	"episodeType": `ViewMore_episodeType__6eo37`,
	"scrollTrack": `ViewMore_scrollTrack__FOLZ8`,
	"scrollBar": `ViewMore_scrollBar__1Nx-j`,
	"noEpisodes": `ViewMore_noEpisodes__H93hD`
};
export default ___CSS_LOADER_EXPORT___;
